import { ViewRoom, ViewTable } from '@xeetr/types/models'
import { ChevronDown, ChevronUp, Plus } from 'lucide-react'
import { useFieldArray, useFormContext } from 'react-hook-form'
import { v4 as uuidv4 } from 'uuid'

import { useWindowSize } from '../../../../hooks/common/useWindowSize'
import HeaderBadges from '../../common/HeaderBadges'

import { Button } from '@/components/ui/button'
import { cn } from '@/lib/utils'

interface Props {
  toggleCollapse: () => void
  tables: ViewTable[]
  collapsed?: boolean
}

const TableHeader = ({ collapsed, toggleCollapse, tables }: Props) => {
  const { control } = useFormContext<ViewRoom>()
  const { width: windowWidth } = useWindowSize()
  const { append } = useFieldArray({
    control,
    name: 'tables',
  })
  const ToggleIcon = collapsed ? ChevronDown : ChevronUp

  const badgesClassNames = cn(
    { 'opacity-100': collapsed, 'opacity-0': !collapsed },
    'transition-opacity duration-500'
  )

  const addTable = () => {
    const newTable: ViewTable = {
      id: uuidv4(),
      name: 'Neuer Tisch',
      size: 0,
      order: tables.length,
      minCapacity: 0,
      maxCapacity: 0,
      combinableTables: [],
    }
    append(newTable)
  }
  return (
    <div className="flex items-center rounded-md border p-0 pl-2" onClick={() => toggleCollapse()}>
      <Button className="h-full focus:shadow-none" variant="ghost" size="icon">
        <ToggleIcon className="h-4 w-4" />
      </Button>
      <div className="flex w-full flex-col items-start gap-2 p-2 md:flex-row md:items-center md:justify-between md:p-0">
        <div className="flex items-center">
          <label className="mx-2 md:my-auto md:text-xl">
            Tische<span className={badgesClassNames}>:</span>
          </label>
          <div className={badgesClassNames}>
            <HeaderBadges length={windowWidth <= 500 ? 4 : 5} values={tables} />
          </div>
        </div>
        <div
          className="text-primary align-self-end ml-2 flex items-center"
          onClick={(e) => e.stopPropagation()}
        >
          <Button
            className="min-h-[54px] rounded-l-none md:min-w-[11rem] md:place-content-center"
            onClick={() => addTable()}
          >
            {windowWidth > 500 ? (
              <>
                <Plus className="h-4 w-4" />
                Tisch hinzufügen
              </>
            ) : (
              <Plus className="h-4 w-4" />
            )}
          </Button>
        </div>
      </div>
    </div>
  )
}

export default TableHeader
